module.exports = __webpack_public_path__ + "assets/star-filled.edd76c7e.svg";